// Notebook ruling geometry for PAINTING the ruled paper
// (components/CanvasPaperBackground.tsx derives its CSS gradient from these).
//
// LAYOUT IS NOT DONE HERE — this file is geometry for the painted sheet and
// nothing else. The gateway owns placement, so it also owns the ruling:
// `gateway/src/canvas-ops/paper-grid.ts` puts every element ON a rule line.
// Never re-snap here: an unreported shift desyncs the gateway's scene bounds.
//
// CONTRACT: RULE_SPACING / RULE_OFFSET / MARGIN_X are duplicated in the
// gateway and MUST match it. Their home there is now
// `gateway/src/canvas-ops/geometry-config.ts` (`GEOMETRY.paper`), which
// paper-grid.ts re-exports; the gateway pins these same three literals in its
// `__tests__/geometry-config.test.ts` for the same reason this app pins them
// in `__tests__/notebookGrid.test.ts`, so an unpaired edit fails a build on
// BOTH sides rather than silently drifting.
//
// One asymmetry worth knowing: the gateway's copies are env-overridable
// (`NOTEPAD_GEOM_RULE_SPACING` and friends). Nothing carries such an override
// across to this app, and no test can see it, so overriding those three at
// deploy time would paint the sheet from one lattice and place content on
// another. Treat them as deploy-blocking unless this app ships alongside. They are not imported from
// @ever-tutor/et-ui because the gateway and this app are on different majors of
// that package, so single-sourcing them would gate changes on a package
// release. If you change a number here, change it there in the same PR.

/** Vertical distance between blue rule lines. */
export const RULE_SPACING = 74;
/** Y of the first painted rule's bottom edge (gradient background offset). */
export const RULE_OFFSET = 18;
/** Painted thickness of a blue rule / the red margin line, in px. */
export const RULE_THICKNESS = 2;
/** X of the red left margin (writing starts at or right of it). */
export const MARGIN_X = 80;

/**
 * Y of the n-th rule line — the bottom edge of the painted band, which is what
 * content rests on. Mirrors the gateway's `lineY` in paper-grid.ts.
 *
 * `lineY(0)` is the clipped top edge of the sheet, so the first line anything
 * (including a printed line number) sits on is 1.
 */
export function lineY(n: number): number {
  return RULE_OFFSET + n * RULE_SPACING;
}
